import * as types from './types';
export default {
  [types.SET_NOTIFICATION_BANNER](state, payload) {
    state.notification = payload;
  }
};